import type { ReactElement } from "react";
import {
  isContainmentOverdue,
  type ContainmentPlanAction,
} from "@playbookai/widget-schemas";
import { cn } from "../../lib/utils.js";
import { EFFECT_TEXT, shortDate } from "./presentation.js";

/** Execution status never substitutes for effectiveness. */
export function ContainmentActionSummary({
  action,
}: {
  action: ContainmentPlanAction;
}): ReactElement {
  return (
    <span className="flex min-w-0 flex-wrap items-start justify-between gap-x-4 gap-y-1">
      <span className="min-w-0 flex-1 basis-48">
        <span className="block break-words text-sm font-medium text-pb-text">
          {action.action || "Untitled action"}
        </span>
        <span className="mt-1 flex flex-wrap gap-x-2 text-xs text-pb-text-muted">
          <span
            className={cn(
              "break-words",
              !action.owner.trim() && "text-pb-amber-text",
            )}
          >
            {action.owner.trim() || "Unowned"}
          </span>
          <span>{action.eta ? shortDate(action.eta) : "No ETA"}</span>
          {isContainmentOverdue(action) && (
            <span className="text-pb-red-text">Overdue</span>
          )}
        </span>
      </span>
      <span className="shrink-0 text-end text-xs text-pb-text-secondary">
        <span className="block">{action.status}</span>
        {action.effectiveness !== "Not yet assessed" && (
          <span className={cn("mt-1 block", EFFECT_TEXT[action.effectiveness])}>
            {action.effectiveness}
          </span>
        )}
      </span>
    </span>
  );
}
